/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Sync_SuccessInputs */



/**
* | output |
* | --- |
* | "Tournament registered with VEKN." |
*
* @param {Vekn_Sync_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sync_success = /** @type {((inputs?: Vekn_Sync_SuccessInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sync_SuccessInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournoi enregistré auprès de la VEKN.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Torneo registrado en la VEKN.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneio registrado na VEKN.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torneo registrato presso la VEKN.")
	return /** @type {LocalizedString} */ ("Tournament registered with VEKN.")
});